import { useEffect, useState } from "react";

import { BrowserRouter } from "react-router-dom";

//Componentes
import AvisoManutencao from "@/frontend/componentes/AvisoManutencao";
import AvisoNovaVersao from "@/frontend/componentes/AvisoNovaVersao";

//Context
import { useAuth } from "@/frontend/context/auth";

//Common
import { BASE_NAME, PATH_FERRAMENTA_ADM_SYSTEM } from "@/common/constantes.js";

//Util
import { fn_aplicarTema, fn_getTemaTenant } from "@/frontend/utils/tema.js";
import { fn_getPathTenant } from "./utils/sessao";
import useSaveShortcut from "./utils/useSaveShortcut";

//API
import { api_listar, ROTA_LISTAR } from "@/frontend/services/api/api_list";

//Telas
import AppRotas from "@/frontend/AppRotas";

function App() {
  const { signed, sessaoUsuario } = useAuth();

  useSaveShortcut();

  //### USE STATE ###
  const [listTenant, setListTenant] = useState([]);

  //### USE EFFECT ###
  //Inicialização da tela
  useEffect(() => {
    //Lista os tenants para montas as possíveis rotas de login
    async function listarTenant() {
      const result = await api_listar(ROTA_LISTAR.TENANT_LOGIN, "situacao=A");
      setListTenant(result);
    }

    const url = window.location.pathname.split("/");
    let path = url[BASE_NAME ? 3 : 2];

    if (!path) {
      const rota = url[BASE_NAME ? 2 : 1];

      path =
        rota.startsWith("sys_") || rota == "dashboard_system"
          ? PATH_FERRAMENTA_ADM_SYSTEM
          : fn_getPathTenant(sessaoUsuario);
    }

    listarTenant();

    //Aplica o tema do tenant
    fn_aplicarTema(fn_getTemaTenant(path));
  }, []);

  return (
    <BrowserRouter
      basename={BASE_NAME || undefined}
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <AvisoManutencao />
      <AvisoNovaVersao />

      <AppRotas
        signed={signed}
        sessaoUsuario={sessaoUsuario}
        listTenant={listTenant}
      />
    </BrowserRouter>
  );
}

export default App;
